// extracted by mini-css-extract-plugin
export default {"display":"Display_display__wDEtC","bonus":"Display_bonus__ycZH1","result":"Display_result__fofSc"};